<template>
    <div class="col-md-12">
        <form @submit.prevent="updateLocation">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-3">
                        <div class="h2">#{{ location.name }}</div>
                    </div>
                </div>
            </div>

            <div class="container-fluid bg-light py-3">
                <div class="controls">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="location.name=='' && isSubmit? 'border-danger':''">
                                    <input type="text" autocomplete="none" required
                                           class="form-control border-0 py-0 shadow-none form-input"
                                           placeholder="Location name"
                                           v-model="location.name">
                                    <div class="help-block with-errors"></div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="location.warehouse_id=='' && isSubmit? 'border-danger':''">
                                    <select required class="form-control border-0 py-0 shadow-none pr-5"
                                            v-model="location.warehouse_id">
                                        <option v-for="warehouse in warehouses" :value="warehouse.id">
                                            {{ warehouse.nickname }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="location.type=='' && isSubmit? 'border-danger':''">
                                    <select required class="form-control border-0 py-0 shadow-none pr-5"
                                            v-model="location.type">
                                        <option value='10'>Transit</option>
                                        <option value='20'>Warehouse</option>
                                    </select>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>

                <div class="row">
                    <div class="col-md-12">
                        <button type="submit" class="btn btn-primary" @click="validation()">Save</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-muted"></p>
                    </div>
                </div>
            </div>

        </form>

        <br/>

        <a href="/locations" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>
    </div>
</template>
<script>
export default {
    name: "LocationEdit",
    props: {
        url: {type: String, required: true}
    },
    data() {
        return {
            location: {},
            warehouses: {},
            isSubmit: false
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        updateLocation() {
            axios.patch(`/locations/${this.location.id}`, this.location).then((response) => {
                window.location.reload();
            }).catch(err => console.log(err))
        },
        fetchData() {
            let dataFetchUrl = `${this.url}`
            axios.get(dataFetchUrl)
                .then(({data}) => {
                    this.location = data;
                }).catch();
            axios.get('/warehouse-list')
                .then(({data}) => {
                    this.warehouses = data;
                }).catch();
        },
    },
    created() {
        return this.fetchData()
    },
}
</script>
<style>
.optimoroute-result {
    margin-top: 10px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.location-block-height {
    height: 750px;
}

.float-end {
    margin-left: 100px;
}

</style>
